import { defineRule } from '../rule.js';

/** Accepted deviation between the source voltage and a voltage the device accepts. */
export const VOLTAGE_TOLERANCE = 0.1;

/** True if `supply` is within ±10 % of one of the accepted voltages. */
export function voltageAccepted(supply: number, accepted: readonly number[]): boolean {
  return accepted.some((v) => Math.abs(supply - v) <= v * VOLTAGE_TOLERANCE);
}

/** E: a device is powered from a source whose voltage it does not accept (and no transformer). */
export const voltageMismatch = defineRule(
  'voltage-mismatch',
  'error',
  { en: 'Wrong mains voltage', de: 'Falsche Netzspannung' },
  (data, emit) =>
    Object.values(data.items).flatMap((item) => {
      const voltages = item.power?.voltages ?? [];
      const sourceId = item.power?.sourceId;
      const source = sourceId === undefined ? undefined : data.power[sourceId];
      if (source === undefined || voltages.length === 0 || source.transformer === true) return [];
      if (voltageAccepted(source.voltage, voltages)) return [];
      return [
        emit([item.id, source.id], { voltage: source.voltage, accepted: voltages.join('/') }),
      ];
    }),
);
